import 'rxjs/add/observable/fromPromise';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import 'rxjs/add/observable/throw';

import {Injectable} from '@angular/core';
import {Headers, Http, Jsonp, RequestOptions, Response} from '@angular/http';
import {Observable} from 'rxjs/Observable';
import {Subscription} from 'rxjs/Subscription';

import {environment} from '../../../environments/environment';
import {AuthBody} from '../model/authBody';
import {AuthResponse} from '../model/authResponse';
import {ErrorResponse} from '../model/errorResponse';
import {Module} from '../model/module';
import {SignedRequest} from '../model/signedRequest';
import {User} from '../model/user';
import {SessionService} from './session.service';

const API_URL = environment.apiUrl;

@Injectable()
export class UploadService {
  constructor(private http: Http, private sessionService: SessionService) {}

  public getSignedUpload(fileName: string, fileType: string):
      Observable<SignedRequest> {
    const headers = new RequestOptions({
      headers: new Headers(
          {'Authorization': 'Bearer ' + localStorage.getItem('token')})
    });
    return this.http
        .get(
            API_URL + '/v1/uploads/s3/signed?file_name=' + fileName +
                '&file_type=' + fileType,
            headers)
        .map(response => {
          return new SignedRequest(response.json());
        })
        .catch(this.handleError.bind(this)) as Observable<SignedRequest>;
  }

  public uploadFileToS3(signedRequest: SignedRequest, file: File):
      Observable<string|number> {
    const xhr = new XMLHttpRequest;

    return Observable.create(observer => {
      xhr.upload.onprogress = (event) => {
        const progress = Math.round(event.loaded / event.total * 100);
        observer.next(progress);
      };

      xhr.onreadystatechange = () => {
        if (xhr.readyState === 4) {
          if (xhr.status === 200) {
            observer.next(xhr.statusText);
            observer.complete();
          } else {
            observer.error(xhr.response);
          }
        }
      };

      xhr.open('PUT', signedRequest.signed_request + '');
      xhr.setRequestHeader('x-amz-acl', 'public-read');
      xhr.send(file);

      return () => xhr.abort();
    });
  }

  public uploadUsersToApi(organisation: string, file): Observable<Response> {
    const headers = new RequestOptions({
      headers: new Headers(
          {'Authorization': 'Bearer ' + localStorage.getItem('token')})
    });

    const body = {
      file: file
    };

    return this.http
        .post(API_URL + '/v1/imports/' + organisation + '/users', body, headers)
        .map(response => {
          return response.json();
        })
        .catch(this.handleError.bind(this));
  }

  public uploadUsersFilterToApi(file): Observable<Response> {
    const headers = new RequestOptions({
      headers: new Headers(
          {'Authorization': 'Bearer ' + localStorage.getItem('token')})
    });

    const body = {
      file: file
    };

    return this.http
        .post(API_URL + '/v1/imports/filters/users', body, headers)
        .map(response => {
          return response.json();
        })
        .catch(this.handleError.bind(this));
  }

  private handleError(error: Response|any) {
    console.log(error);
    return this.sessionService.handleAuthenticatedRequestError(error);
  }
}



// WEBPACK FOOTER //
// /tmp/build_f0fbff5b/src/app/data/services/upload.service.ts